import React, {useEffect, useMemo, useState} from "react";
import {
    useGlobalFilter,
    usePagination,
    useSortBy,
    useTable,
} from "react-table";
// Assets
import CardMenu from "components/card/CardMenu";
import {MdChevronLeft, MdChevronRight, MdEdit, MdSendToMobile} from "react-icons/md";
import Card from "components/card";
import {useUserAuth} from "../../../../context/UserAuthContext";
import {AES, enc} from "crypto-js";
import {useNavigate} from "react-router-dom";
import axios from "axios";
import {FaEye} from "react-icons/fa";
import {toast} from 'react-toastify';

const AdsInfoTable = (props) => {
    const {columnsData, tableData} = props;

    const columns = useMemo(() => columnsData, [columnsData]);
    const data = useMemo(() => tableData, [tableData]);

    const [isNotifyModalOpen, setIsNotifyModalOpen] = useState(false);
    const [searchQuery, setSearchQuery] = useState("");
    const [filteredUsers, setFilteredUsers] = useState([]);
    const [selectedAd, setSelectedAd] = useState(null);
    const [showFullImage, setShowFullImage] = useState(null);
    const [selectedUsers, setSelectedUsers] = useState([]); // To store checked users
    const [selectedUsernames, setSelectedUsernames] = useState([]);

    const allUsers = [
        // Add more as needed
    ];

    // Toggle selection for a user
    /*const handleUserSelection = (user) => {
        setSelectedUsers((prev) => {
            const alreadySelected = prev.some((u) => u.id === user.id);
            return alreadySelected
                ? prev.filter((u) => u.id !== user.id)
                : [...prev, user];
        });
    };*/
    const handleUserSelection = (user) => {
        setSelectedUsers((prev) => {
            const alreadySelected = prev.some((u) => u.id === user.id);

            if (alreadySelected) {
                // If deselecting, remove user + username
                setSelectedUsernames((prevNames) =>
                    prevNames.filter((name) => name !== user.username)
                );
                return prev.filter((u) => u.id !== user.id);
            } else {
                // If selecting, add user + username
                setSelectedUsernames((prevNames) => [
                    ...prevNames,
                    user.username,
                ]);
                return [...prev, user];
            }
        });
    };

    const handleOpenNotifyModal = (ad) => {
        setSelectedAd(ad);
        setSearchQuery("");
        setFilteredUsers(allUsers); // Default: show all
        setIsNotifyModalOpen(true);
    };

    const handleSearchChange = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);
        setFilteredUsers(
            allUsers.filter((user) =>
                user.name.toLowerCase().includes(query) || user.phone.includes(query)
            )
        );
    };

    const handleSendToUser = async (user) => {
        //console.log("Sending ad:", selectedAd, "to user:", user);
        // TODO: call your API to send ad to this user
        const requestBody = {
            title: selectedAd.title,
            description: selectedAd.description,
            buttonText: selectedAd.buttonText,
            buttonUrl: selectedAd.buttonUrl,
            expiryDate: selectedAd.expiryDate,
            imageUrl: selectedAd.imageUrl
        }
        //console.log(requestBody);
        try {
            const response = await axios.post(
                CROMPTON_URL + "notifications/ads",
                {
                    title: selectedAd.title,
                    description: selectedAd.description,
                    buttonText: selectedAd.buttonText,
                    buttonUrl: selectedAd.buttonUrl,
                    expiryDate: selectedAd.expiryDate,
                    imageUrl: selectedAd.imageUrl
                },
                {
                    headers: {
                        Authorization: user.token,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200) {
                toast.success(`Notification sent to ${user.mobileNumber}`);
                //console.log(`✅ Notification sent to ${user.mobileNumber}`);
            } else {
                //console.log(response)
                toast.error("Failed to send notification");
                //console.error("❌ Failed to send notification");
            }
        } catch (error) {
            //console.log(error)
            toast.error("Failed to send notification");
            //console.error("Error sending notification:", error);
        }
    };

    const handleSendToGroup = async () => {
        try {
            const response = await axios.post(
                CROMPTON_URL + "notifications/ads/sendSpecific",
                {
                    title: selectedAd.title,
                    description: selectedAd.description,
                    buttonText: selectedAd.buttonText,
                    buttonUrl: selectedAd.buttonUrl,
                    expiryDate: selectedAd.expiryDate,
                    imageUrl: selectedAd.imageUrl,
                    usernames: selectedUsernames,
                },
                {
                    headers: {
                        Authorization: decryptedValue,
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.status === 200) {
                toast.success(response.data.message);
                //console.log(`✅ Notification sent to ${user.mobileNumber}`);
            } else {
                //console.log(response)
                toast.error("Failed to send notification");
                //console.error("❌ Failed to send notification");
            }
        } catch (error) {
            //console.log(error)
            toast.error("Failed to send notification");
            //console.error("Error sending notification:", error);
        }
    }

    const handleSendToAll = async () => {
        //console.log("Sending ad to all users:", selectedAd);
        // TODO: call your API to send ad to all users
        try {
            const response = await axios.post(
                CROMPTON_URL + "notifications/ads/sendAll",
                {
                    title: selectedAd.title,
                    description: selectedAd.description,
                    buttonText: selectedAd.buttonText,
                    buttonUrl: selectedAd.buttonUrl,
                    expiryDate: selectedAd.expiryDate,
                    imageUrl: selectedAd.imageUrl,
                   /* usernames: selectedUsernames,*/
                },
                {
                    headers: {
                        Authorization: decryptedValue,
                        "Content-Type": "application/json",
                    },
                }
            );

            console.log("Sending ad to all users:", selectedAd);

            if (response.status === 200) {
                toast.success(response.data.message);
                console.log(`✅ Notification sent to`);
            } else {
                console.log(response)
                toast.error("Failed to send notification");
                //console.error("❌ Failed to send notification");
            }
        } catch (error) {
            console.log(error)
            toast.error("Failed to send notification");
            //console.error("Error sending notification:", error);
        }
    };

    function convertGMTtoIST(gmtDateTime) {
        // Create a new Date object with the GMT date and time
        const gmtDate = new Date(gmtDateTime);

        // Get the time zone offset for IST
        const istOffset = gmtDate.getTimezoneOffset() + 330; // IST is UTC+5:30

        // Create a new Date object with the IST date and time
        const istDate = new Date(gmtDate.getTime() + istOffset);

        // Return the IST date and time in DD/MM/YYYY HH:MM format
        return istDate.toLocaleString('en-IN', {timeZone: 'Asia/Kolkata'});
    }

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    //const CROMPTON_ANALYTICS_URL = "https://iot.crompton.co.in:8443/AAPI/"
    const secretKey = "cromptonssecretkey";
    const [message, setErrorMessage] = useState("");

    let {Token, logOut, Username, accesscontrollevel} = useUserAuth();
    const decryptedValue = AES.decrypt(Token, secretKey).toString(enc.Utf8);

    const [allFeedbacks, setAllFeedbacks] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const navigate = useNavigate();

    const tableInstance = useTable(
        {
            columns,
            data,
        },
        useGlobalFilter,
        useSortBy,
        usePagination
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,

        prepareRow,
        nextPage,
        previousPage,
        setPageSize,

        setGlobalFilter,
        state,
    } = tableInstance;

    const {pageSize} = state;
    const currentPage = state.pageIndex; // Page index starts from 0
    const totalPages = Math.ceil(data.length / pageSize);

    const getDaysInMonth = (year, month) => new Date(year, month, 0).getDate()
    const addMonths = (input, months) => {
        const date = new Date(input)
        date.setDate(1)
        date.setMonth(date.getMonth() + months)
        date.setDate(Math.min(input.getDate(), getDaysInMonth(date.getFullYear(), date.getMonth() + 1)))
        return date.toISOString().slice(0, 10)
    }

    const handleLogOut = async () => {
        try {
            await logOut();
            navigate("/");
        } catch (error) {
            ////console.log(error.message);
        }
    }

    const handleSearchSubmit = async () => {
        if (!searchQuery.trim()) return;

        /*// Optional: Validate mobile number format
        if (!/^\d{10}$/.test(searchQuery)) {
            toast.error("Enter valid 10-digit mobile number or a valid email address");
            //alert("Enter valid 10-digit mobile number");
            return;
        }*/
        var url = CROMPTON_URL + "user/getByMobile/" + searchQuery;

        await axios({
            method: "GET", url: url, headers: {
                Authorization: decryptedValue,
            }

        }).then((res) => {

            if (res.data) {
                setFilteredUsers([res.data]); // Add to list
            } else {
                setFilteredUsers([]);
            }

        }).catch((error) => {
            setErrorMessage(error.response.data.message)
            setFilteredUsers([]);
            if (error.response.data.status === "401" || error.response.data.status === "403") {
                handleLogOut();
            }
        })

    };

    return (
        <Card extra={"w-full px-9 py-3 h-full"}>
            {/* tables */}
            <div className="mt-[25px] overflow-x-auto max-w-full">
                <table
                    {...getTableProps()}
                    className="table-auto whitespace-nowrap font-dm text-navy-700"
                >
                    <thead>
                    {headerGroups.map((headerGroup, index) => (
                        <tr
                            {...headerGroup.getHeaderGroupProps()}
                            key={index}
                            className="border-b border-gray-200 text-base dark:border-white/10"
                        >
                            {headerGroup.headers.map((column, index) => (
                                <th
                                    {...column.getHeaderProps(column.getSortByToggleProps())}
                                    className="pb-[15px] pl-[5px] pr-[20px] text-start text-sm font-bold uppercase tracking-wide text-gray-600"
                                    key={index}
                                >
                                    {column.render("Header")}
                                </th>
                            ))}
                        </tr>
                    ))}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                    {page.map((row, index) => {
                        prepareRow(row);
                        return (
                            <tr {...row.getRowProps()} key={index} className="items-center">
                                {row.cells.map((cell, index) => {
                                    let data = "";
                                    if (cell.column.Header === "Id") {
                                        data = (
                                            <div className="flex items-center gap-2 min-w-[200px] pr-4">
                                                <div className="flex flex-col">
                                                    <p className="text-sm font-bold text-navy-700 dark:text-white">
                                                        {cell.value}
                                                    </p>
                                                    {/*<p className="text-sm font-medium text-gray-600">
                                                    {cell.value[1]}
                                                </p>*/}
                                                </div>
                                            </div>
                                        );
                                    } else if (
                                        ["Title", "Description", "Button Text", "Expiry Date", "Active"].includes(cell.column.Header)
                                    ) {
                                        data = (
                                            /*<div className="text-sm font-bold dark:text-white min-w-[120px]">*/
                                            <div className="flex items-center gap-2 min-w-[200px] max-w-[1000px] pr-4">
                                                <div className="flex flex-col whitespace-normal break-words">
                                                    {cell.value}
                                                </div>
                                            </div>
                                        );
                                    } else if (
                                        ["Created Time", "Last Updated"].includes(cell.column.Header)
                                    ) {
                                        data = (
                                            /*<div className="text-sm font-bold dark:text-white min-w-[120px]">*/
                                            <div className="flex items-center gap-2 min-w-[200px] max-w-[1000px] pr-4">
                                                <div className="flex flex-col whitespace-normal break-words">
                                                    {convertGMTtoIST(cell.value)}
                                                </div>
                                            </div>
                                        );
                                    } else if (cell.column.Header === "NOTIFY") {
                                        data = (
                                            <button
                                                className="text-xl text-blue-800"
                                                onClick={() => handleOpenNotifyModal(cell.row.original)}
                                            >
                                                <MdSendToMobile/>
                                            </button>
                                        );
                                    } else if (
                                        ["Button URL"].includes(cell.column.Header)
                                    ) {
                                        data = (
                                            /*<div className="text-sm font-bold dark:text-white min-w-[120px]">*/
                                            <div className="flex items-center gap-2 min-w-[200px] max-w-[1000px] pr-4">
                                                <div className="flex flex-col whitespace-normal break-words">
                                                    {cell.value?.startsWith("http") ? (
                                                        <a
                                                            href={cell.value}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-[#004c86] underline hover:text-blue-800 dark:text-blue-400 italic font-bold"
                                                        >
                                                            {cell.value}
                                                        </a>
                                                    ) : (
                                                        cell.value
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    }
                                    /*else if (
                                        ["Image URL"].includes(cell.column.Header)
                                    ) {
                                        data = (
                                            /!*<div className="text-sm font-bold dark:text-white min-w-[120px]">*!/
                                            <div className="flex items-center gap-2 min-w-[200px] max-w-[1000px] pr-4">
                                                <div className="flex flex-col whitespace-normal break-words">
                                                    {cell.value?.startsWith("http") ? (
                                                        <a
                                                            href={cell.value}
                                                            target="_blank"
                                                            rel="noopener noreferrer"
                                                            className="text-[#004c86] underline hover:text-blue-800 dark:text-blue-400 italic font-bold"
                                                        >
                                                            {cell.value}
                                                        </a>
                                                    ) : (
                                                        cell.value
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    }*/
                                    else if (["Image"].includes(cell.column.Header)) {
                                        data = (
                                            <div className="flex items-center gap-2 min-w-[200px] max-w-[500px] pr-4">
                                                {cell.value?.startsWith("http") ? (
                                                    <div
                                                        className="relative flex items-center justify-center w-[80px] h-[80px] rounded-md bg-gray-100 overflow-hidden">
                                                        {/* Thumbnail */}
                                                        <img
                                                            src={cell.value}
                                                            alt="Thumbnail"
                                                            className="w-full h-full object-cover"
                                                        />

                                                        {/* Eye Button */}
                                                        <button
                                                            onClick={() => setShowFullImage(cell.value)} // pass the url
                                                            className="absolute top-1 right-1 flex items-center justify-center w-7 h-7 rounded-full
                          backdrop-blur-sm bg-white/80 text-black border border-black shadow-md hover:bg-white transition z-10"
                                                            title="View Full Image"
                                                        >
                                                            <FaEye size={14} color="#004c86"/>
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <span className="text-sm text-gray-600 dark:text-gray-300">
                    {cell.value}
                </span>
                                                )}
                                            </div>
                                        );
                                    }


                                    return (
                                        <td
                                            className="py-[14px] pl-2 pr-4 align-middle"
                                            {...cell.getCellProps()}
                                            key={index}
                                        >
                                            {data}
                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })}
                    </tbody>
                </table>
            </div>

            {/* pagination */}
            <div className=" mt-2 flex h-20 w-full items-center justify-between px-6">
                {/* left side */}
                <div className=" flex items-center gap-3">
                    <p className="> Show rows per page text-sm text-gray-700 font-bold dark:text-white">
                        Show rows per page{" "}
                    </p>
                    <select
                        value={pageSize}
                        onChange={(e) => setPageSize(Number(e.target.value))}
                        className="h-[32px] w-[75px] rounded-[20px] border border-gray-700 px-2 text-gray-700 font-bold dark:!border-white/10 dark:bg-navy-800 dark:text-white"
                        name=""
                        id=""
                    >
                        <option value="10">10</option>
                        <option value="20">20</option>
                        <option value="30">30</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
                <div className="flex items-center gap-4">
                    <p className="text-sm font-bold text-gray-700 dark:text-white">
                        Page {currentPage + 1} of {totalPages}
                    </p>
                </div>
                {/* right side */}
                <div className="flex items-center gap-3">
                    {state.pageIndex !== 0 && (
                        <button
                            onClick={previousPage}
                            disabled={state.pageIndex === 0}
                            className={`linear flex items-center justify-center rounded-full bg-[#004c86] p-2 text-lg text-white transition duration-200 hover:bg-[#004c86] active:bg-[#004c86] dark:bg-[#004c86] dark:text-white dark:hover:bg-[#004c86] dark:active:bg-[#004c86] `}
                        >
                            <MdChevronLeft/>
                        </button>
                    )}
                    <p className="text-sm text-gray-700 font-bold dark:text-white ">
                        {currentPage + 1}
                    </p>
                    {state.pageIndex !== totalPages - 1 && (
                        <button
                            onClick={nextPage}
                            disabled={state.pageIndex === totalPages}
                            className={`linear flex items-center justify-center rounded-full bg-[#004c86] p-2 text-lg text-white transition duration-200 hover:bg-[#004c86] active:bg-[#004c86] dark:bg-[#004c86] dark:text-white dark:hover:bg-[#004c86] dark:active:bg-[#004c86] `}
                        >
                            <MdChevronRight/>
                        </button>
                    )}
                </div>
            </div>

            {isNotifyModalOpen && (
                <div
                    className="fixed inset-0 z-50 bg-black bg-opacity-40 flex justify-center items-center backdrop-blur-sm">
                    <div className="bg-white dark:bg-gray-800 w-full max-w-lg rounded-lg p-6">
                        <h2 className="text-lg font-semibold mb-4 dark:text-white text-[#004c86]">
                            Notify Users
                        </h2>

                        {/* 🔍 Search */}
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyDown={(e) => e.key === "Enter" && handleSearchSubmit()}
                            placeholder="Search by mobile number or email address"
                            className="w-full border px-3 py-2 mb-4 rounded dark:bg-gray-700 dark:text-white"
                        />

                        {/* 📋 User List */}
                        <div className="max-h-60 overflow-y-auto border rounded-md mb-4">
                            {filteredUsers.length > 0 ? (
                                filteredUsers.map((user) => (
                                    <div
                                        key={user.id}
                                        className="flex justify-between items-center py-2 px-3 border-b dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-700"
                                    >
                                        <div className="flex items-center space-x-3">
                                            <input
                                                type="checkbox"
                                                checked={selectedUsers.some((u) => u.id === user.id)}
                                                onChange={() => handleUserSelection(user)}
                                                className="cursor-pointer w-4 h-4 accent-[#004c86]"
                                            />
                                            <div className="text-sm dark:text-white">
                                                <p className="font-medium">
                                                    {user.name && user.name.trim() !== ""
                                                        ? user.name
                                                        : user.mobileNumber
                                                            ? user.mobileNumber
                                                            : user.email}
                                                </p>
                                                <p className="text-gray-500 text-xs">
                                                    {user.mobileNumber || user.email || ""}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <p className="text-gray-500 dark:text-gray-300 text-center py-3">
                                    No users found.
                                </p>
                            )}
                        </div>

                        {/* 🧾 Selected Users */}
                        {selectedUsers.length > 0 && (
                            <div className="mb-4 bg-gray-50 dark:bg-gray-700 p-3 rounded-md">
                                <h3 className="text-sm font-semibold text-[#004c86] dark:text-white mb-2">
                                    Selected Users ({selectedUsers.length})
                                </h3>
                                <div className="flex flex-wrap gap-2">
                                    {selectedUsers.map((user) => (
                                        <span
                                            key={user.id}
                                            className="bg-[#004c86] text-white text-xs px-2 py-1 rounded-full flex items-center space-x-1"
                                        >
          {/* ✅ Show name if available, else mobile number */}
                                            <span>
  {user.name && user.name.trim() !== ""
      ? user.name
      : user.mobileNumber
          ? user.mobileNumber
          : user.email}
</span>
          <button
              onClick={() => handleUserSelection(user)}
              className="ml-1 text-xs font-bold hover:text-gray-200"
          >
            ×
          </button>
        </span>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Footer Actions */}
                        <div className="mt-6 flex justify-between">
                            <button
                                onClick={handleSendToGroup}
                                disabled={selectedUsers.length === 0}
                                className={`px-4 py-2 rounded text-white ${
                                    selectedUsers.length === 0
                                        ? "bg-gray-400 cursor-not-allowed"
                                        : "bg-[#004c86] hover:bg-[#0b83b5]"
                                }`}
                            >
                                Notify Selected
                            </button>

                            <button
                                onClick={handleSendToAll}
                                className="bg-[#0b83b5] hover:bg-green-700 text-white px-4 py-2 rounded"
                            >
                                Notify All
                            </button>

                            <button
                                onClick={() => setIsNotifyModalOpen(false)}
                                className="bg-gray-300 dark:bg-gray-600 text-black dark:text-white px-4 py-2 rounded hover:bg-gray-400"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {/*
            {isNotifyModalOpen && (
                <div
                    className="fixed inset-0 z-50 bg-black bg-opacity-40 flex justify-center items-center backdrop-blur-sm">
                    <div className="bg-white dark:bg-gray-800 w-full max-w-lg rounded-lg p-6">
                        <h2 className="text-lg font-semibold mb-4 dark:text-white text-[#004c86]">
                            Notify to User
                        </h2>

                         Search
                        <input
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleSearchSubmit();
                                }
                            }}
                            placeholder="Search by mobile number"
                            className="w-full border px-3 py-2 mb-4 rounded dark:bg-gray-700 dark:text-white"
                        />

                         User List
                        <div className="max-h-60 overflow-y-auto">
                            {filteredUsers.length > 0 ? (
                                filteredUsers.map((user) => (
                                    <div
                                        key={user.id}
                                        className="flex justify-between items-center py-2 border-b dark:border-gray-600"
                                    >
                                        <div className="text-sm dark:text-white">
                                            <p>{user.name}</p>
                                            <p className="text-gray-500">{user.mobileNumber}</p>
                                        </div>
                                        <button
                                            onClick={() => handleSendToUser(user)}
                                            className="bg-[#004c86] text-white px-3 py-1 rounded hover:bg-[#0b83b5]"
                                        >
                                            Send
                                        </button>
                                    </div>
                                ))
                            ) : (
                                <p className="text-gray-500 dark:text-gray-300">No users found.</p>
                            )}
                        </div>

                         Footer Actions
                        <div className="mt-6 flex justify-between">
                            <button
                                onClick={handleSendToAll}
                                className="bg-[#0b83b5] hover:bg-green-700 text-white px-4 py-2 rounded"
                            >
                                Notify All
                            </button>
                            <button
                                onClick={() => setIsNotifyModalOpen(false)}
                                className="bg-gray-300 dark:bg-gray-600 text-black dark:text-white px-4 py-2 rounded hover:bg-gray-400"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}*/}

            {showFullImage && (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-80 p-4"
                    onClick={() => setShowFullImage(null)}
                >
                    <img
                        src={showFullImage}
                        alt="Full Preview"
                        className="max-h-full max-w-full object-contain rounded-lg shadow-lg"
                    />
                </div>
            )}

        </Card>
    );
};

export default AdsInfoTable;
